import { render, staticRenderFns } from "./EditNotifications.vue?vue&type=template&id=15df8930&scoped=true&lang=pug&"
import script from "./EditNotifications.vue?vue&type=script&lang=js&"
export * from "./EditNotifications.vue?vue&type=script&lang=js&"
import style0 from "./EditNotifications.vue?vue&type=style&index=0&id=15df8930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15df8930",
  null
  
)

export default component.exports